$(document).ready(function() {
    // Show the first tab content by default
    $('#Tab1').addClass('active');
    $('.tab-button[data-tab="Tab1"]').addClass('active');

    // Click event for tab buttons
    $('.tab-button').click(function() {
        var tabName = $(this).data('tab');

        // Hide all tab content
        $('.tab-content').removeClass('active');

        // Remove the active class from all buttons
        $('.tab-button').removeClass('active');

        // Show the current tab and add an "active" class to the button that opened the tab
        $('#' + tabName).addClass('active');
        $(this).addClass('active');

if(tabName == 'Tab1'){
$('.charm-container').addClass('d-none');
$('.pdp-images').removeClass('d-none');
$('[data-option-index="2"]').show();
}else if(tabName == 'Tab2'){
$('[data-option-index="2"]').hide();
$('.charm-container').removeClass('d-none');
$('.pdp-images').addClass('d-none');
}else{
  $('[data-option-index="2"]').hide();
var color = $('[data-position="1"]:checked').val();
$('.rev-item-option.option-0').text(color);
var size = $('[data-position="2"]:checked').val();
$('.rev-item-option.option-1').text(size);
var charmLimitAmt = $('#charmLimitAmt').text() * 1;
if(charmLimitAmt == 0){
$('.customizer-collapsible').hide();
$('.customizer-collapsible-content').hide();
}else{
$('.customizer-collapsible').show();
$('.customizer-collapsible-content').show();
$('.customizer-collapsible span').text(`${charmLimitAmt} Selected`);
 $('.customizer-collapsible-content').append('');
$('.ui-state-default').each(function(index) {
var title = $(this).data('name');
var image = $(this).data('custom-img');
var html = `<li class="collapsible-item" data-collapsible-item="${index}">
            <div class="collapsible-item__content__image">
            <img src="${image}" alt="${title}">
            </div>
            <div class="collapsible-item__title">${title}</div>
          </li>`;
    $('.customizer-collapsible-content').append(html);
})

}
}

    });


 $('.variant-picker__option-val input').change(function() {
        // Get the value of the changed input
        var selectedValue = $(this).val();
var imageUrl;
if(selectedValue ==='18K White Gold'){
  imageUrl = 'https://stephaniegottlieb.com/cdn/shop/files/white-gold-slider_large.png?v=1699658026';
}else if(selectedValue ==='18K Yellow Gold'){
   imageUrl = 'https://cdn.shopify.com/s/files/1/0157/0550/files/WhatsApp_Image_2024-07-10_at_21.02.26_791715be.jpg?v=1720804349';
}else{
 imageUrl = 'https://cdn.shopify.com/s/files/1/0157/0550/files/WhatsApp_Image_2024-07-10_at_21.02.26_524fc1d8.jpg?v=1720804349';
}
$('#charmBank').css('background-image', 'url(' + imageUrl + ')');
$('.variant-picker_option legend span').text(selectedValue);
        // Find the input in .swatches__container with the same value
        var correspondingInput = $('.swatches__container input[value="' + selectedValue + '"]');

        // Find the next label element after the corresponding input
        var nextLabel = correspondingInput.next('label');

        // Click the next label if it exists
        if (nextLabel.length) {
            nextLabel.click();
        }
    });


$('.view-charm-container').click(function() {
$('.charm-container').removeClass('d-none');
$('.pdp-images').addClass('d-none');
$('.tab-content').removeClass('active');
 $('.tab-button').removeClass('active');
$('[data-tab="Tab2"]').addClass('active');
$('#Tab2').addClass('active');
  $('[data-option-index="2"]').hide();
});


$('.back-to-imgs').click(function() {
$('.charm-container').addClass('d-none');
$('.pdp-images').removeClass('d-none');
$('.tab-content').removeClass('active');
 $('.tab-button').removeClass('active');
$('[data-tab="Tab1"]').addClass('active');
$('#Tab1').addClass('active');
   $('[data-option-index="2"]').show();
});


$('#letter-type').change(function() {
var color = $('.variant-picker__option-values input:checked').val();
var type = $('#letter-type').val();
$('.swatch-value-container').addClass('d-none');
$('.swatch-value-container').removeClass('d-inline-block');

// if(type === 'Flower Power Symbols' || type === 'Fly With Me Symbols' || type === 'Peace and Leaf Symbols' || type === 'Protect yourself Symbols' || type === 'Love Symbols' || type === 'Gemstone' ){
// $(`[data-charm-type="${type}"]`).removeClass('d-none');
// $(`[data-charm-type="${type}"]`).addClass('d-inline-block');
// }else{
$(`[data-value-text="${color} | ${type}"]`).removeClass('d-none');
$(`[data-value-text="${color} | ${type}"]`).addClass('d-inline-block');
// }

});
$('.variant-picker__option-values input').click(function() {
var color = $('.variant-picker__option-values input:checked').val();
var type = $('#letter-type').val();
$('.swatch-value-container').removeClass('d-inline-block');
$('.swatch-value-container').addClass('d-none');
$(`[data-value-text="${color} | ${type}"]`).removeClass('d-none');
$(`[data-value-text="${color} | ${type}"]`).addClass('d-inline-block');
});

$('.swatch-value-container').click(function() {
var charmLimitAmt = $('#charmLimitAmt').text() * 1;
if(charmLimitAmt < 7){
charmLimitAmt++;
$('#charmLimitAmt').text(charmLimitAmt);
var img = $(this).find('.tooltip-select').data('img');
var letter = $(this).find('.tooltip-select').data('letter');
var type = $(this).find('.tooltip-select').data('type');
var letters = $(this).find('.tooltip-select').data('letters');
var variant_id = $(this).find('.tooltip-select').data('variant_id');
var html = `<li class="ui-state-default custom-charms white-gold-white-diamond charms-item mr-2" data-variant_id="${variant_id}" data-pos="${charmLimitAmt}" data-letters="${letters}" data-name="${letter}" data-type="${type}" data-custom-img="${img}" draggable="">
            <div class="charm-real-img right-angle original" style="background-image: url('${img}');"></div>
            <span class="remove-charm-cont d-none">
                <span class="remove-charm" data-name="${letter}" data-pos="${charmLimitAmt}" >x</span>
            </span>
        </li>`;
$('#sortable').append(html);
}
updateLineItem();
});




$('#removeAllCharms').click(function() {

var charmLimitAmt = $('#charmLimitAmt').text() * 1;
if(charmLimitAmt == 0){
 $('#popup-container-empity').css('display', 'flex');
}else{
 $('#popup-container-remove').css('display', 'flex');
}
});
$('#editCharmsbtn').click(function() {
var charmLimitAmt = $('#charmLimitAmt').text() * 1;
if(charmLimitAmt == 0){
 $('#popup-container-empity').css('display', 'flex');
}else{
$('.remove-charm-cont').toggleClass('d-none');
}
});
$('.removeAllCharmsOk').click(function() {
$('#charmLimitAmt').text(0);
$('#sortable').html('');
$('.popup-container').css('display', 'none');
});

 $('.popup-close,.removeAllCharmsCancel').click(function() {
        $('.popup-container').css('display', 'none');
});


  $("#sortable").sortable({
        update: function(event, ui) {
            // Get the new order of elements
            $('#sortable > li').each(function(index, element) {
                // Update the data-pos attribute
                $(element).attr('data-pos', index + 1);
                // Update the order attribute
                $(element).attr('order', index + 1);
            });
        }
    });
    $("#sortable").disableSelection();
  
$(document).on("click",".remove-charm",function() {
var charmLimitAmt = $('#charmLimitAmt').text() * 1;
if(charmLimitAmt > 0){
charmLimitAmt--;
$('#charmLimitAmt').text(charmLimitAmt);
}
  $(this).parents('li').remove();
  updateLineItem();
});

$('.customizer-collapsible').click(function() {
  $(this).toggleClass('active');
$('.customizer-collapsible-content').toggleClass('active');
});
});

function updateLineItem() {

$('.custom-form-options').html('');
$('#sortable .ui-state-default').each(function(index, element) {
  
var name = $(this).data('name');
var type = $(this).data('type');
var variant_id = $(this).data('variant_id');
 var html = `<input type="text" name="properties[Charms-${index}]" value="${name}">
<input type="text" name="properties[_Charms-id-${index}]" value="${variant_id}">
<input type="hidden" name="items[${index}][id]" value="${variant_id}">
<input type="hidden" name="items[${index}][properties[_charm]]" value="true">
`;
$('.custom-form-options').append(html);
});  
}

